import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { HotelInfo, Metric } from '@features/deals/types';
import PropertyDetailsCard from '@features/deals/components/WizardShared/PropertyDetailsCard';
import MarketAnalysisCard from '@features/deals/components/WizardShared/MarketAnalysisCard';
import FinancialPerformanceTable from '@features/deals/components/WizardShared/FinancialPerformanceTable';

interface ReviewAnalyzeStepProps {
  hotelInfo: HotelInfo;
  metrics: Metric[];
  hotelAiAnalysis: any;
}

const ReviewAnalyzeStep: React.FC<ReviewAnalyzeStepProps> = ({
  hotelInfo,
  metrics,
  hotelAiAnalysis
}) => {
  // Get unique years from metrics
  const years = Array.from(new Set(metrics.map((m) => m.year))).sort();

  return (
    <Box sx={{ maxWidth: '100%', backgroundColor: '#f8f9fa', borderRadius: 3, p: 4 }}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          mb: 4,
          fontWeight: 600,
          color: '#1a237e', // Dark blue color for the title
          borderBottom: '2px solid',
          borderColor: 'primary.main',
          pb: 2
        }}
      >
        Property Analysis Report
      </Typography>

      <Grid container spacing={4}>
        {/* Hotel Information Section */}
        <Grid item xs={12} md={6}>
          <PropertyDetailsCard hotelInfo={hotelInfo} />
        </Grid>

        {/* Hotel AI Analysis Section */}
        {hotelAiAnalysis && (
          <Grid item xs={12} md={6}>
            <MarketAnalysisCard analysis={hotelAiAnalysis} />
          </Grid>
        )}

        {/* Financial Metrics Section */}
        <Grid item xs={12}>
          <FinancialPerformanceTable metrics={metrics} years={years} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReviewAnalyzeStep;